import { SessionOptions } from "iron-session";

// Define the structure of customer details
export interface TypeCustomerDetails {
  id: string;
  firstName: string;
  lastName: string;
  gender: string;
  dob: string;
  email: string;
}

export interface SessionData {
  email: string;
  isLoggedIn: boolean;
  token: string;
  error: string;
  customerDetails: TypeCustomerDetails;
}

export const defaultSession: SessionData = {
  email: "",
  isLoggedIn: false,
  token: "",
  error: "",
  customerDetails: {
    id: "",
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    email: "",
  },
};

export const sessionOptions: SessionOptions = {
  password: process.env.SESSION_ENCRYPTION_KEY!,
  cookieName: "duke-session",
  cookieOptions: {
    secure: true,
    httpOnly: true,
    maxAge: undefined,
  },
};

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
